export enum SUBSCRIPTION_PLAN {
  PREMIUM_12 = 'PREMIUM_12',
  PREMIUM_1 = 'PREMIUM_1',
  KINGZ_PREMIUM_1 = 'KINGZ_PREMIUM_1',
  KINGZ_PREMIUM_12 = 'KINGZ_PREMIUM_12',
  YOUR_PREMIUM_1 = 'YOUR_PREMIUM_1',
  YOUR_PREMIUM_12 = 'YOUR_PREMIUM_12',
  ipn_product = 'ipn_product',
}
